import { useQuery } from "react-query";
import axiosInstance from "../../services/axiosInstance";

const fetchPriceCalcBooking = async (
  pl: BookingRequestDTO[],
  props?: {
    params: { updateBookingMode?: boolean };
  },
) => {
  const { data } = await axiosInstance.post("/price-calc/booking", pl, {
    params: props?.params,
  });
  if (data?.error) {
    throw new Error(data.error);
  }
  return data?.result;
};

export const useCalcPriceQuery = (
  pl: BookingRequestDTO[],
  props?: {
    params: { updateBookingMode?: boolean };
  },
  enabled: boolean | undefined = true,
) => {
  return useQuery<PriceResponseDTO>({
    queryKey: [
      "booking",
      "price",
      JSON.stringify(pl),
      props ? JSON.stringify(props) : undefined,
    ].filter((x) => x),
    retry: false,
    queryFn: async () => {
      if (!pl?.length) {
        return createEmptyPriceResponse();
      }
      try {
        return await fetchPriceCalcBooking(pl, props);
      } catch (e) {
        console.error(e);
        return createEmptyPriceResponse();
      }
    },
    keepPreviousData: true,
    // enabled: !!pl && pl.length > 0,
    enabled: enabled,
  });
};
//       pl.every((p) => !!p.productId && p.bookingDetails.length > 0),

const createEmptyPriceResponse = (): PriceResponseDTO => ({
  priceOfSingleBookings: [],
  originalTotalAmount: 0,
  serviceFeeAmount: 0,
  voucherAmount: 0,
  passDiscountAmount: 0,
  productDiscountAmount: 0,
  paidAmount: 0,
  discountAmount: 0,
  beforeServiceFeeTotalOfOrder: 0,
  beforeServiceFeeTotal: 0,
  cartTotal: 0,
  refundAmount: 0,
});
